<template>
  <el-container class="shopList">
    <el-header class="box add bb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>模块管理</el-breadcrumb-item>
        <el-breadcrumb-item>模块列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="Add()"
          size="medium"
          >新增模块</el-button
        >
      </div>
    </el-header>
    <el-main class="">
      <div class="pt20" style="text-align: left">
        <el-form :inline="true" :model="page" class="demo-form-inline">
          <el-form-item>
            <el-input
              placeholder="模块名称"
              v-model="page.name"
              clearable
              @clear="onSubmit"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <el-row class="box search">
       <el-form :inline="true"  :model="page" class="demo-form-inline">
        <el-col :span="4" class="mr10">
             <el-form-item size="medium" >
         <el-input placeholder="模块名称" v-model="page.name" clearable class="input-with-select" @clear="onSubmit">
            </el-input>
        </el-form-item>
        </el-col>
        <el-col :span="4" class="tl">
           <el-form-item  size="medium">
          <el-button  type="primary"  @click="onSubmit" class="general_bgc general_border cfff">查询</el-button>
        </el-form-item>
        </el-col>
       
      </el-form>
    </el-row> -->
      <div class="box list">
        <el-table border :data="tableData" style="width: 100%">
          <el-table-column
            prop="name"
            min-width="80"
            :show-overflow-tooltip="true"
            label="模块名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="icon"
            min-width="80"
            :show-overflow-tooltip="true"
            label="模块图标"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="color"
            min-width="80"
            :show-overflow-tooltip="true"
            label="模块颜色"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="path"
            min-width="80"
            :show-overflow-tooltip="true"
            label="模块路径"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="created_name"
            min-width="80"
            :show-overflow-tooltip="true"
            label="创建者"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            min-width="100"
            :show-overflow-tooltip="true"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="orange disib"
                size="mini"
                @click="goUpdate(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                class="red"
                size="medium"
                @click="godelete(scope.row.id, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="i-page fr disib mt20">
          <el-pagination
            background
            :page-size="10"
            layout="total,prev, pager, next"
            :total="total"
            :current-page="currentPage"
            @current-change="currentChange"
          >
          </el-pagination>
        </div> -->
      </div>
    </el-main>
  </el-container>
</template>
<script>
import axios from "../../../../util/api";
import { mapState } from "vuex";
import { session } from "../../../../util/util";
import { imageUrl } from "../../../../config/index";
export default {
  data() {
    return {
      imageUrl: imageUrl,
      page: {
        pager_offset: "0",
        pager_openset: "10",
        menu_level: "1",
        menu_name: "",
      },
      currentPage: 1,
      total: 0,
      tableData: [],
    };
  },
  computed: {
    ...mapState({
      menuPage: (state) => state.menu.menuPage,
    }),
  },
  created() {
    this.page = Object.assign({}, this.menuPage);
    this.currentPage = this.page.pager_offset / 10 + 1;
    this.init(this.page);
  },
  methods: {
    init(params) {
      axios.get("/pc/menu/appMenuList", params).then((v) => {
        this.tableData = v.data.menu_list;
        this.total = v.data.pager_count;
      });
    },
    Add() {
      session.set("params", { id: "", name: "" });
      this.$router.push({ path: "appMenu/add" });
    },
    //编辑菜单
    goUpdate(index) {
      session.set("params", { id: index, name: "" });
      this.$router.push({ path: "appMenu/add" });
    },
    // 搜索
    onSubmit() {
      this.currentPage = 1;
      this.page.pager_offset = "0";
      this.$store.dispatch("menu/setNewPage", this.page);
      this.init(this.page);
    },
    // 分页
    currentChange(page) {
      this.currentPage = page;
      this.page.pager_offset = String((page - 1) * 10);
      this.$store.dispatch("menu/setNewPage", this.page);
      this.init(this.page);
    },
    godelete(val, index) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        axios
          .delete("/pc/menu/deleteAppMenu", { id: String(val) })
          .then((v) => {
            this.tableData.splice(index, 1);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.shopList {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-input-group__append .el-button--primary .el-icon-search {
    color: #fff;
  }
}
</style>
